import { render, staticRenderFns } from "./SoalMapelList.vue?vue&type=template&id=01e0da6c&scoped=true"
import script from "./SoalMapelList.vue?vue&type=script&lang=js"
export * from "./SoalMapelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e0da6c",
  null
  
)

export default component.exports